import LinkOnSelectedInterface from '../../Types/Interface/MethodInterface/LinkOnSelectedInterface';
import { GarbageCollectorInterface } from '../../Types/Interface/TableInterfaces/DataInterface/DataInterface';
import AdminScreenPathsList from '../BeecomingDatas/AdminScreenPathsList';

/**
 * @param data Garbage collet array
 * @returns a link usable to create exception for each Garbage collect selected
 */
function getPath(data: GarbageCollectorInterface[]): string {
  let link: string = AdminScreenPathsList['waste-collect-exception'];
  const l = data.length;
  if (l > 0) {
    link += `?collecteId=${data[0].collecteid}`;
  }
  for (let i = 1; i < l; i += 1) {
    link += `&collecteId=${data[i].collecteid}`;
  }
  return link;
}

const GarbageCollectExcetionLink: LinkOnSelectedInterface<GarbageCollectorInterface> = {
  title: 'Créer une exception',
  getPath,
};

export default GarbageCollectExcetionLink;
